import { fetchWithAuth } from '../utils/fetchWithAuth';

export const listMinutes = async (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== '')
  ).toString();
  const res = await fetchWithAuth(`/minutas${qs ? `?${qs}` : ''}`, { method: 'GET' });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

export const createMinute = async (payload) => {
  // payload: { file, title, meetingDate, location?, summary?, participants[], tags[] }
  const fd = new FormData();
  fd.append('file', payload.file);
  fd.append('title', payload.title);
  fd.append('meetingDate', payload.meetingDate);
  if (payload.location) fd.append('location', payload.location);
  if (payload.summary) fd.append('summary', payload.summary);
  fd.append('participants', JSON.stringify(payload.participants || []));
  fd.append('tags', JSON.stringify(payload.tags || []));
  const res = await fetchWithAuth('/minutas', { method: 'POST', body: fd });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const deleteMinute = async (id) => {
  const res = await fetchWithAuth(`/minutas/${encodeURIComponent(id)}`, { method: 'DELETE' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.message || `HTTP ${res.status}`);
  }
  return res.json();
};

export const updateMinute = async (id, payload) => {
  // 1) PUT de metadatos
  const meta = {
    title: payload.title,
    meetingDate: payload.meetingDate,
    location: payload.location || '',
    summary: payload.summary || '',
    participants: payload.participants || [],
    tags: payload.tags || [],
  };
  let res = await fetchWithAuth(`/minutas/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(meta),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.message || `HTTP ${res.status}`);
  }

  // 2) Si viene nuevo archivo, reemplazar PDF
  if (payload.file) {
    const fd = new FormData();
    fd.append('file', payload.file);
    res = await fetchWithAuth(`/minutas/${encodeURIComponent(id)}/file`, {
      method: 'PATCH',
      body: fd,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.message || `HTTP ${res.status}`);
    }
  }

  return true;
};
